export default __webpack_public_path__ + "static/product-unit-9-health-b0dc2627d657917fd2651ce735b217ac.png";